import script from "./ListarMateriais.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarMateriais.vue?vue&type=script&setup=true&lang=js"

import "./ListarMateriais.vue?vue&type=style&index=0&id=9521707a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9521707a"]])

export default __exports__